import { ActionType } from "../../../../../../react-core/Flux/ActionType";
import { SwitchDispatcher } from "../Store/Variable";
import { CommissionChargeClient } from "../../../../../../Wrap/Api/Charge/CommissionCharge";
import { CommissionCharge } from "../../../../../../Wrap/Models/Models/Charges/CommissionCharge";
import { PensionContributionInstructionClient } from "../../../../../../Wrap/Api/Apply/PensionContributionInstruction";
import { IsaContributionInstructionClient } from "../../../../../../Wrap/Api/Apply/IsaContributionInstruction";
import { GiaContributionInstructionClient } from "../../../../../../Wrap/Api/Apply/GiaContributionInstruction";
import { ProcessType as ActivityType } from "../../../../../../Wrap/Constants/Enums/Client/DashboardFilter/ProcessType";
import { SubAccountType } from "../../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { SubAccountTypeHelper } from "../../Common/Helpers/SubAccountTypeHelper";
import { PensionContributionModel } from "../../../../../../Wrap/Models/Models/Processes/Apply/Pension/PensionContributionModel";
import { GiaContributionModel } from "../../../../../../Wrap/Models/Models/Processes/Apply/PersonalPortfolio/GiaContributionModel";
import { IsaContributionModel } from "../../../../../../Wrap/Models/Models/Processes/OneOffPayment/Isa/IsaContributionModel";
import { SubAccountAmendmentInstructionClient } from "../../../../../../Wrap/Api/Apply/SubAccountAmendmentInstruction";
import { InstructionProcessClient } from "../../../../../../Wrap/Api/Instruction/InstructionProcess";
import { BatchClient } from "../../../../../../Wrap/Api/Orders/Batch";
import { BatchType } from "../../../../../../Wrap/Constants/Enums/Orders/Batch/BatchType";

export class SwitchAction {
    public static checkFBRC(subAccountHierarchyId: string, callback: (result: CommissionCharge) => void) {
        const client = new CommissionChargeClient();
        const promise = client.get(subAccountHierarchyId);

        promise.onSuccess((result) => {
            callback(result);
        });
    }

    // public static savePensionInvestmentPath(data, callback?) {
    //     const subaccountid = getQueryParameters()["subaccounthierarchyid"];
    //     const client = new DrawdownInvestmentStrategyClient();
    //     let promise = client.post(subaccountid, data.InvestmentPathwayAnswers);
    //     promise.onSuccess((result) => {
    //         if(callback) callback(result)
    //     });
    //     promise.onError((err) => {
    //         if(callback) callback(err)
    //     });
    // }

    public static getInstruction(
        id: string,
        productType: SubAccountType,
        hierarchyId: string,
        subAccountHierarchyId: string,
        clientId: number
    ): void {
        if (SubAccountTypeHelper.isPP(productType)) {
            const giaContributionInstruction = new GiaContributionInstructionClient();
            this.getOrCreateInstruction(
                giaContributionInstruction,
                id,
                hierarchyId,
                subAccountHierarchyId,
                clientId
            );
        } else if (SubAccountTypeHelper.isIsa(productType)) {
            const isaContributionInstruction = new IsaContributionInstructionClient();
            this.getOrCreateInstruction(
                isaContributionInstruction,
                id,
                hierarchyId,
                subAccountHierarchyId,
                clientId
            );
        } else if (SubAccountTypeHelper.isOnPlatformPension(productType)) {
            const nprContributionInstruction = new PensionContributionInstructionClient();
            this.getOrCreateInstruction(
                nprContributionInstruction,
                id,
                hierarchyId,
                subAccountHierarchyId,
                clientId
            );
        }
    }

    public static saveInstruction(
        from, 
        data: 
            | PensionContributionModel
            | GiaContributionModel
            | IsaContributionModel,
        type: SubAccountType, 
        customerId?: number, 
        callback?: (data) => void
    ): void {
        if (SubAccountTypeHelper.isOnPlatformPension(type)) {
            const pensionContributionInstruction = new PensionContributionInstructionClient();
            const promise = pensionContributionInstruction.put(data, customerId,null);
            this.updateSwtichInstructionStore(promise, callback);
        } else if (SubAccountTypeHelper.isPP(type)) {
            const giaContributionInstruction = new GiaContributionInstructionClient();
            const promise = giaContributionInstruction.put(data, "");
            this.updateSwtichInstructionStore(promise, callback);
        } else if (SubAccountTypeHelper.isIsa(type)) {
            const client = new IsaContributionInstructionClient();
            const promise = client.put(data);
            this.updateSwtichInstructionStore(promise, callback);
        }
    }

    public static submitInstruction(
        hierarchyId: string,
        data: any,
        customerId,
        clAccountId,
        callback?: VoidFunction
    ): void {
        const client = new SubAccountAmendmentInstructionClient();
        const promise = client.put(hierarchyId, data, customerId, clAccountId);
        promise.onSuccess((result) => {
            if (callback) {callback();}
        });
    }

    public static deleteInstruction(id, callback?: VoidFunction): void {
        const client = new SubAccountAmendmentInstructionClient();
        const promise = client.delete(id);
        promise.onSuccess((result) => {
            if (callback) {callback();}
        });
    }

    public static postInstructionProcess(instructionId: number, processType: ActivityType) {
        const client = new InstructionProcessClient();
        const promise = client.post(instructionId, processType);
    }

    private static getOrCreateInstruction(
        client:
            | PensionContributionInstructionClient
            | IsaContributionInstructionClient
            | GiaContributionInstructionClient,
        id: string,
        hierarhcyId: string,
        subAccountHierarchyId: string,
        clientId: number
    ) {
        if (id && id !== "") {
            // Have instructionId
            const promise = client.get(id, clientId, "", null);
            this.updateSwtichInstructionStore(promise);
        } else {
            // Create new instruction
            const promise = client.post(subAccountHierarchyId, hierarhcyId, ActivityType.Switch);
            promise.onSuccess((result) => {
                const instructionId = result.Result;
                const model = client.get(instructionId, clientId, "", null);
                this.updateSwtichInstructionStore(model);
            });

            promise.onError((error) => {
                SwitchDispatcher.dispatch({
                    actionType: ActionType.Error,
                    payload: error
                })
            });
        }
    }

    private static updateSwtichInstructionStore(promise: any, callback?: (data) => void) {
        promise.onSuccess((result) => {
            SwitchDispatcher.dispatch({
                actionType: ActionType.Success,
                payload: result,
            });
            if (callback) {
                callback(result);
            }
        });

        promise.onError((error) => {
            SwitchDispatcher.dispatch({
                actionType: ActionType.Error,
                payload: error,
            });
        });
    }

    public static getBatchId(data,subAccountHierarchyId) {
        let promise;
        let model = {
            HierarchyId: subAccountHierarchyId,
            ActionDate: data?.Contribution?.SwitchInstructionModel?.ActionDate,
            BatchType: BatchType.OneOff,
            OrderType: BatchType.OneOff,
            InvestmentPathwayAnswers: { PersonalRecommendation: true },
        };
        const client = new BatchClient();
        promise = client.post(model);
        promise.onSuccess((result) => {
            SwitchDispatcher.dispatch({
                actionType: ActionType.Success,
                payload: {
                    ...data,
                    BatchId: result.BatchId,
                    BatchType: BatchType.OneOff,
                    OrderType: BatchType.OneOff,
                    ActionDate: result.ActionDate,
                },
            });
        });
        promise.onError((err) => {});
    }
}
